/** @format */

import React, { useState } from "react";
import Image from "components/Image";
// import LoginBackgroundImage from "assets/images/LoginImageMobile.png";
import CarouselOverlay from "assets/icons/CarouselOverlay.svg";
import { useGoogleLogin } from "@react-oauth/google";
import { ENVIRONMENT, ROUTE_BASED_URL } from "definition";
import { useNavigate } from "react-router-dom";
import { useAppStore } from "store/useAppStore";
import Carousel from "components/Carousel";
import Loader from "components/Loader";
import LoginImage from "assets/images/LoginImage.png";
import LoginButton from "components/LoginButton";
import ImageOverlayText from "components/Login/ImageOverlayText";
import LoginBackgroundImage from "assets/images/tyons/LoginBackgroundImage.png";
import Button from "components/Button";
import GoogleIcon from "@mui/icons-material/Google";
import BusinessTag from "components/1tyons/BusinessTag";
import EarlyAccess from "components/EarlyAccess";

const Login = () => {
  const navigate = useNavigate();
  const SetCredits = useAppStore().setCredits;
  const updateNewUser = useAppStore().updateNewUser;
  const innerHeight = window.innerHeight;
  const innerWidth = window.innerWidth;
  const [loading, setLoading] = useState(false);

  const handleLogin = useGoogleLogin({
    onSuccess: async (response) => {
      SIGN_IN(response);
    },
  });

  const SIGN_IN = async (response: any) => {
    setLoading(true);
    await fetch(`${ROUTE_BASED_URL}imagine_interior/signup/send_email`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${response.access_token}`,
      },
    })
      .then(async (res) => {
        if (res.status === 200 || res.status === 201) {
          const response = await res.json();
          localStorage.setItem("token", response.jwt);
          updateNewUser(response.new_user);
          if (localStorage.getItem("token") !== "undefined") {
            setLoading(false);
            window.location.href = "/uploadimage";
          }
          SetCredits(response.remaining_credits);
        }
      })
      .catch((err) => {
        setLoading(false);
      });
  };
  //   alert(ENVIRONMENT);
  return (
    <div>
      {ENVIRONMENT === "development" ? (
        <div
          style={{
            backgroundImage: `url(${LoginBackgroundImage})`,
            backgroundSize: "cover",
            backgroundPosition: "center",
            width: "100%",
            height: "100vh",
          }}
        >
          <div className="flex flex-col justify-center items-center h-full px-[1rem]">
            <div className="flex items-center gap-1.5 mb-[1.5rem]">
              <h3
                style={{ textShadow: "2px 4px 15px rgba(14,216,226,0.79)" }}
                className="text-[2rem] font-semibold  text-turquoise text-center "
              >
                tryons
              </h3>
              <span className="mt-1.5">
                <BusinessTag />
              </span>
            </div>
            <p className="text-[1.3rem] text-white text-center mb-[0.7rem] font-semibold">
              Transform Your Fashion Experience
            </p>
            <p className="text-[1.3rem] text-white text-center font-light">
              Upload your garments and see them come to life on your chosen
              models with the power of AI.
            </p>
            <div className="mt-[2rem]">
              <Button
                buttonText="Sign In with Google"
                icon={<GoogleIcon />}
                onclick={handleLogin}
                classname="w-fit px-[3rem] font-semibold mx-auto"
              ></Button>
              <p className="text-white mt-[1.3rem] text-[0.9rem] text-center">
                By Signing with Google you agree to our{" "}
                <span className="text-turquoise hover:underline cursor-pointer">
                  Privacy Policy
                </span>{" "}
                and{" "}
                <span className="text-turquoise hover:underline cursor-pointer">
                  Terms and Conditions
                </span>
              </p>
            </div>
          </div>
        </div>
      ) : (
        <EarlyAccess />
      )}
    </div>
  );
};

export default Login;
